import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';

export default function TitleTagSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {['passed', 'warning'].includes(result.status) && (
                    <TitleTagResult
                        status={result.status}
                        content={result.content}
                        titleLength={result.title_length}
                    />
                )}

                {result.status === 'failed' && result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                        render={(result) =>
                            ['passed', 'warning'].includes(result.status) && (
                                <TitleTagResult
                                    status={result.status}
                                    content={result.content}
                                    titleLength={result.title_length}
                                />
                            )
                        }
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type TitleTagResultProps = {
    status: string;
    content: string;
    titleLength: number;
};

function TitleTagResult({ status, content, titleLength }: TitleTagResultProps) {
    return (
        <div className={`result-meta ${status}`}>
            <div>
                <strong>Text: </strong>
                {content}
            </div>
            {titleLength && (
                <div>
                    <strong>Length: </strong>
                    {titleLength} characters
                </div>
            )}
        </div>
    );
}
